import { useCallback, useEffect, useState } from "react"
import { StaffSchedule } from "../interfaces"

export type Brush =
  | { kind: "shift"; shiftTypeId: number }
  | { kind: "eraser" }
  | null

/**
 * Активная кисть палитры. `null` — режим просмотра: по гриду можно скроллить и выделять
 * текст, ничего не меняя.
 */
export const useBrush = (legend: Map<number, StaffSchedule.ShiftType>) => {
  const [brush, setBrush] = useState<Brush>(null)

  // Активный тип исчез из справочника (мягкое удаление в другой вкладке) — кисть сбрасывается:
  // POST /create с удалённым типом вернёт ошибку на каждый мазок.
  // `legend.size > 0` — страховка от сброса на пустой легенде (ошибка загрузки справочника):
  // временно недоступный справочник не должен выбивать пользователя из режима рисования.
  useEffect(() => {
    if (
      brush?.kind === "shift" &&
      legend.size > 0 &&
      !legend.has(brush.shiftTypeId)
    ) {
      setBrush(null)
    }
  }, [brush, legend])

  // Повторный клик по активному элементу палитры снимает выбор — иначе из режима
  // рисования нельзя выйти, не выбрав другую кисть.
  const toggleShift = useCallback(
    (shiftTypeId: number) =>
      setBrush((b) =>
        b?.kind === "shift" && b.shiftTypeId === shiftTypeId
          ? null
          : { kind: "shift", shiftTypeId },
      ),
    [],
  )
  const toggleEraser = useCallback(
    () => setBrush((b) => (b?.kind === "eraser" ? null : { kind: "eraser" })),
    [],
  )
  const clearBrush = useCallback(() => setBrush(null), [])

  return { brush, toggleShift, toggleEraser, clearBrush }
}
